const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- select-user-dialog ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    confirm: { type: String, default: 'Select' },
    hint: String,
  }

  init() {
    this.state.query = ''
    this.state.person = null
    this.state.unknown = ''
    this.state.error = ''
    this.state.busy = ''
  }

  typed(value) {
    this.state.query = value
    if (this.state.person || this.state.unknown || this.state.error) {
      this.state.person = null
      this.state.unknown = ''
      this.state.error = ''
    }
  }

  // Enter finds the person; once found (or offered), Enter picks them.
  async submit(event) {
    event.preventDefault()
    if (this.state.person) return this.pick()
    if (this.state.unknown) return this.invite()
    const query = (this.formData(event.target).person || '').trim().toLowerCase()
    if (!query) return
    this.state.busy = 'find'
    this.state.error = ''
    try {
      this.state.person = await window.App.api('user/find', { person: query }, { silent: true })
    } catch (error) {
      if (error.code !== 'not_found') this.state.error = error.details?.person || error.message
      else if (query.includes('@')) this.state.unknown = query
      else this.state.error = 'No one has that username.'
    } finally {
      this.state.busy = ''
    }
  }

  async invite() {
    this.state.busy = 'invite'
    this.state.error = ''
    try {
      this.state.person = await window.App.api('user/invite', { email: this.state.unknown }, { silent: true })
      this.state.unknown = ''
      this.pick()
    } catch (error) {
      this.state.error = error.details?.email || error.message
    } finally {
      this.state.busy = ''
    }
  }

  pick() {
    const { user, email } = this.state.person
    window.Dialog.close({ ...user, email })
  }

  CSS = `:fez {
display:block;form{display:grid;gap:var(--space-4)}.su-person{display:flex;align-items:center;gap:var(--space-3);padding:var(--space-3);border:1px solid var(--color-border);border-radius:var(--radius-md);background:var(--color-bg-subtle)}.su-who{display:grid;min-width:0}.su-name{overflow:hidden;font-weight:var(--weight-semibold);text-overflow:ellipsis;white-space:nowrap}.su-meta{overflow:hidden;color:var(--color-text-muted);font-size:var(--text-sm);text-overflow:ellipsis;white-space:nowrap}.su-new{margin:0;padding:var(--space-3);border-radius:var(--radius-md);background:var(--color-accent-soft);color:var(--color-text);font-size:var(--text-sm)}
}`

  HTML = `<form onsubmit="fez.submit(event)" novalidate>
<div oninput="fez.typed(event.target.value)"><ui-input name="person" label="Email or username" placeholder="ana@example.com or ana" hint={props.hint || ''} error={state.error} autofocus required></ui-input></div>
{#if state.person}
<div class="su-person">
<ui-avatar :user="state.person.user" size="md"></ui-avatar>
<div class="su-who">
<span class="su-name">{state.person.user.name}</span>
<span class="su-meta">{state.person.user.username ? \`@\${state.person.user.username} · \${state.person.email}\` : \`\${state.person.email} · not signed in yet\`}</span>
</div>
</div>
{:else if state.unknown}
<p class="su-new">No one has an account for <strong>{state.unknown}</strong> yet. Create it now: they pick their username when they first sign in.</p>
{/if}
<div class="dialog-actions">
<ui-button label="Cancel" onclick="Dialog.cancel()"></ui-button>
{#if state.person}
<ui-button type="submit" variant="primary" label={props.confirm}></ui-button>
{:else if state.unknown}
<ui-button type="submit" variant="primary" icon="user-plus" label="Create account" :loading="state.busy === 'invite'"></ui-button>
{:else}
<ui-button type="submit" variant="primary" icon="magnifying-glass" label="Find" :loading="state.busy === 'find'"></ui-button>
{/if}
</div>
</form>`
};
}

Fez('select-user-dialog', __fez_component_0);

export default __fez_component_0;
